
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCard,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
  IonCardHeader,
  IonButtons,
  IonButton,
} from '@ionic/vue';
import {defineComponent, ref, onMounted, computed} from 'vue';
import {logoLinkedin, logoGithub, rocketOutline, sunnyOutline, moonOutline, desktopOutline} from 'ionicons/icons';
import {useTheme} from '../composables/useTheme';

import LocalSkillsChart from '../components/LocalSkillsChart.vue';
import LocalGithubActivity from '../components/LocalGithubActivity.vue';
import LocalTechnologyTimeline from '../components/LocalTechnologyTimeline.vue';
import LocalProjects from '../components/LocalProjects.vue';
import LocalSecurityAudits from '../components/LocalSecurityAudits.vue';
import LocalWorkExperience from '../components/LocalWorkExperience.vue';


function calculateWorkExperienceColumns(): number {
  return window.innerWidth < 992 ? 1 : 2
}

const workExperienceColumns = ref(calculateWorkExperienceColumns());
const workExperienceData = ref(null);

window.addEventListener('resize', () => {
  workExperienceColumns.value = calculateWorkExperienceColumns();
});

async function loadWorkExperienceData() {
  try {
    const response = await fetch('/data/work-experience.json');
    workExperienceData.value = await response.json();
  } catch (error) {
    console.error('Failed to load work experience data:', error);
  }
}

export default defineComponent({
  name: 'Home',
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonCard,
    IonCardContent,
    IonGrid,
    IonRow,
    IonCol,
    IonIcon,
    IonCardHeader,
    IonButtons,
    IonButton,
    LocalSkillsChart,
    LocalGithubActivity,
    LocalTechnologyTimeline,
    LocalProjects,
    LocalSecurityAudits,
    LocalWorkExperience,
  },
  setup() {
    const {themePreference, cycleTheme} = useTheme();

    const themeIcon = computed(() => {
      switch (themePreference.value) {
        case 'light':
          return sunnyOutline;
        case 'dark':
          return moonOutline;
        default:
          return desktopOutline;
      }
    });

    onMounted(() => {
      loadWorkExperienceData();
    });

    return {
      workExperienceColumns,
      workExperienceData,
      logoGithub,
      logoLinkedin,
      rocketOutline,
      themePreference,
      cycleTheme,
      themeIcon,
    }
  }
});
